module.exports = __webpack_public_path__ + "static/6-b7cfe9e8752b6ea00ae2a379f768b6b5.jpg";